import React from 'react';
import { inject } from 'mobx-react';

import { SectionLayout } from 'layouts/section';

const styles = require('./imprint-page.styles.scss');


@inject('analyticsStore')
export class ImprintPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/imprint');
  }

  render() {
    return (
      <div className={styles.ImprintPage}>
        <SectionLayout>
          <h1>Impressum</h1>
          <p>
            Verantwortlich für Inhalt gemäß Paragraph 6 MDStV:
          </p>

          <ul className={styles.ContactList}>
            <li>Dr. med. vet. Ann-Kathrin Fritsche</li>
            <li>Mobile Praxis für Tierverhaltensmedizin</li>
            <li>Wilhelm-Stolze-Str. 32</li>
            <li>10249 Berlin</li>
            <li>Mobil: 0174/35 95 658</li>
            <li>e-Mail: kontakt@tierverhalten.berlin</li>
          </ul>

          <p>
            Mitglied der Tierärztekammer Berlin
            Approbation durch das LaGeSo (Turmstr. 21, 10559 Berlin)
          </p>

          <p>
            Ausübung unserer Tätigkeit wird geregelt durch die Bundestierärzteordnung, einsehbar unter www.tieraerztekammer-berlin.de
          </p>

          <p>
            Preisgestaltung entsprechend der Gebührenordnung für Tierärzte (Stand 27.07.2017)
          </p>

          <p>
            <span className={styles.Line}>
              Kleinunternehmer nach Paragraph 19 UStG
            </span>
            <span className={styles.Line}>
              Steuernummer: 1114/295/02158
            </span>
          </p>

          <p>
            Wir betonen, dass wir keinerlei Einfluss auf die Gestaltung und die Inhalte der gelinkten Seiten haben. Deshalb distanzieren wir uns hiermit ausdrücklich von allen Inhalten aller gelinkten Seiten auf den gesamten Webseiten dieses Auftritts (Urteil vom 12. Mai 1998 - 312 O 85/98).
          </p>
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/imprint/imprint.page.jsx